import { useCallback, useState, type Dispatch, type SetStateAction } from 'react'
import type { Slide } from '../../../types'
import { reorderSlides } from './helpers'

export const useSlidesDragAndDrop = ({
  slides,
  setSlides,
  persistOrder,
}: {
  slides: Slide[]
  setSlides: Dispatch<SetStateAction<Slide[]>>
  persistOrder: (orderIds: string[]) => Promise<void>
}) => {
  const [dragId, setDragId] = useState<string | null>(null)

  const onDragStart = useCallback((id: string) => setDragId(id), [])

  const onDropSlide = useCallback(
    (targetId: string, orderedSlides?: Slide[]) => {
      if (!dragId) return
      const updated =
        orderedSlides ??
        reorderSlides({
          slides,
          fromId: dragId,
          targetId,
        })
      if (!updated) return
      setSlides(updated)
      setDragId(null)
      void persistOrder(updated.map((slide) => slide.id))
    },
    [dragId, persistOrder, setSlides, slides],
  )

  return {
    onDragStart,
    onDropSlide,
  }
}
